import React from 'react'
// libs
import { matchPath } from 'react-router'
import { useRouter } from 'hooks/useRouter'
// components
import Grid from '@mui/material/Grid2'
// context
import { MainLayoutAPIContext } from 'containers/MainLayout/layers/API'
// views
import { LeftPart, RightPart, StyledAppBar } from './views'

interface IIncomingProps {
  center?: React.ReactNode
  CTA?: React.ReactNode
  isLoading: boolean
  label?: React.ReactNode
}

const AppBar: React.FC<IIncomingProps> = ({ center, CTA, isLoading, label }) => {
  const router = useRouter()

  const { isDrawerExpanded } = React.useContext(MainLayoutAPIContext)

  return (
    <StyledAppBar
      position='fixed'
      $isExpanded={isDrawerExpanded}
      $isPlanEdit={!!matchPath('/plans/:companyId/edit/:id', router.pathname)}>
      {!isLoading && (
        <>
          <LeftPart justifyContent='flex-start' alignItems='center' container>
            {label}
          </LeftPart>
          {!!center && (
            <Grid justifyContent='center' alignItems='center' container>
              {center}
            </Grid>
          )}
          <RightPart justifyContent='flex-end' alignItems='center' container wrap='nowrap'>
            {CTA}
          </RightPart>
        </>
      )}
    </StyledAppBar>
  )
}

export default AppBar
